"use strict";
exports.__esModule = true;
var util_1 = require("~/js/lib/util/util");
var LOCAL_STORAGE_KEY = 'yy_searchHistoryV2';
var HISTORY_LIMIT = 5;
var INTERVAL = 30 * 12 * 60 * 60 * 1000;
var History = (function () {
    function History() {
        this.LOCAL_STORAGE_KEY = LOCAL_STORAGE_KEY;
        this.limit = HISTORY_LIMIT;
        var nowTime = new Date().getTime();
        var iHistorys = [];
        var localStr = util_1.localStorage.getItem(LOCAL_STORAGE_KEY);
        if (localStr) {
            try {
                iHistorys = JSON.parse(localStr) || [];
                if (util_1.type(iHistorys) !== 'array') {
                    iHistorys = [];
                    util_1.localStorage.setItem(LOCAL_STORAGE_KEY, '[]');
                }
                else {
                    iHistorys = iHistorys.filter(function (item) {
                        if (!item || !item.value || !item.timer) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    });
                }
            }
            catch (er) {
            }
        }
        for (var i = 0; i < iHistorys.length;) {
            var item = iHistorys[i];
            if (!item.timer || nowTime - item.timer > INTERVAL) {
                iHistorys.splice(i, 1);
            }
            else {
                i++;
            }
        }
        if (iHistorys.length > this.limit) {
            iHistorys.length = this.limit;
        }
        var historys = [];
        iHistorys.forEach(function (item) {
            historys.push(item.value);
        });
        this.source = iHistorys;
        this.historys = historys;
    }
    History.prototype.del = function (name) {
        var nameIndex = this.historys.indexOf(name);
        if (nameIndex !== -1) {
            this.historys.splice(nameIndex, 1);
            this.source.splice(nameIndex, 1);
            util_1.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this.source));
        }
    };
    History.prototype.clear = function () {
        this.historys = [];
        this.source = [];
        util_1.localStorage.setItem(LOCAL_STORAGE_KEY, '[]');
    };
    History.prototype.add = function (name) {
        var nameIndex = this.historys.indexOf(name);
        if (nameIndex !== -1) {
            this.historys.splice(nameIndex, 1);
            this.source.splice(nameIndex, 1);
        }
        this.historys.unshift(name);
        this.source.unshift({
            timer: new Date().getTime(),
            value: name
        });
        util_1.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this.source));
    };
    return History;
}());
exports.History = History;
